import React, { useContext } from 'react';
import {
  SocialSharePlatformContextType,
  SocialSharePlatformData,
} from './types';
import useSyncPlatformAccountsToModal from './useSyncPlatformAccountsToModal';

const SocialSharePlatformContext = React.createContext<
  SocialSharePlatformContextType | undefined
>(undefined);

export type SocialSharePlatformProviderProps = {
  value: SocialSharePlatformData;
  children: React.ReactNode;
};

export const SocialSharePlatformProvider: React.FC<SocialSharePlatformProviderProps> = ({
  value,
  children,
}) => {
  useSyncPlatformAccountsToModal(value);

  return (
    <SocialSharePlatformContext.Provider value={value}>
      {children}
    </SocialSharePlatformContext.Provider>
  );
};

export function useSocialSharePlatform() {
  const context = useContext(SocialSharePlatformContext);

  if (context === undefined) {
    throw new Error(
      'useSocialSharePlatform must be used within SocialSharePlatformProvider',
    );
  }

  return context;
}
